import { render, staticRenderFns } from "./ScreenProtectorTypeDetail.vue?vue&type=template&id=14490416"
import script from "./ScreenProtectorTypeDetail.vue?vue&type=script&lang=js"
export * from "./ScreenProtectorTypeDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports